import { cva } from 'class-variance-authority';

export const cardStyles = cva(
  'relative flex flex-col justify-between gap-8 rounded-2xl px-4 py-6 sm:p-12 lg:flex-row lg:items-start',
  {
    variants: {
      theme: {
        default:
          'border border-solid border-primary-300 bg-primary-50 shadow-lg dark:border-white dark:bg-white dark:bg-opacity-[0.05] dark:bg-resourceCardGradient',
        teal: 'border border-white bg-locked-banner-card shadow-lockedBannerCard',
        dark: 'border-cardBorder border border-solid bg-gray-900 bg-[radial-gradient(130%_110%_at_50%_50%,rgba(42,147,152,0.20)_0%,rgba(42,147,152,0.09)_55%,transparent_95%)] text-white shadow-lg',
      },
    },
    defaultVariants: {
      theme: 'default',
    },
  },
);

export const headingStyles = cva('', {
  variants: {
    theme: {
      default: 'text-display-sm font-medium text-gray-900 dark:text-white sm:text-display-md',
      teal: 'font-spaceGrotesk text-display-md font-semibold text-gray-900',
      dark: 'text-display-sm font-medium text-white sm:text-display-md',
    },
  },
  defaultVariants: {
    theme: 'default',
  },
});

export const bodyStyles = cva('', {
  variants: {
    theme: {
      default: 'text-lg text-gray-700 dark:text-gray-300 sm:text-xl',
      teal: 'font-roboto text-xl font-medium text-gray-900',
      dark: 'text-lg text-gray-300 sm:text-xl',
    },
  },
  defaultVariants: {
    theme: 'default',
  },
});
